module.exports = __webpack_public_path__ + "static/media/sudoku2.bc2112a3.png";